import {Component, Input, OnInit } from '@angular/core';
import { faClock } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'wf-usage-goal-panel',
    templateUrl: './usage-goal-panel.component.html',
    styleUrls: ['./usage-goal-panel.component.css'],
    standalone: false
})
export class UsageGoalPanel implements OnInit {
  @Input() minWeeklyTimeGoal: number = 0;
  @Input() avgWeeklyUsage: number = 0;
  clockIcon = faClock;

  constructor() {}

  ngOnInit(): void {}
}
